module.exports = __webpack_public_path__ + "img/home_report_text.d021d610.png";